<template>
  <b-modal
    id="create-vehicle-generic"
    ref="modal"
    @ok="handleOk"
    hide-header
    centered
    size="modal"
    no-close-on-esc
    no-close-on-backdrop
    ok-variant="primary">

    <div>
      <h1 class="page-title mb-4">{{$t(titleModal)}}</h1>
      <b-form-group
        :label="$t(labelInput)"
        class="small-text"
        :invalidFeedback="baseVehicle.invalidFeedback"
        :state="baseVehicle.state"
        label-for="name-input">
        <b-form-input
          id="licensePlate-input"
          v-model="baseVehicle.name">
        </b-form-input>
      </b-form-group>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button @click="hideModal"  class="w-100 mr-2" variant="secondary">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('Cancel')}}</span>
          </div>
        </b-button>
        <b-button  class="w-100" variant="primary"  @click="handleOk($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('annonce.online.button.Submit')}}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import i18n from "../../i18n";

export default {
  data() {
    return {
      baseVehicle:{
        name:null,
        id:null,
        invalidFeedback:null,
        state:null,
      },
    };
  },
  emits : ['returnCreateCustom'],

  props:{
    titleModal: {
      required:true
    },
    labelInput: {
      required:true
    },
    controllerName: {
      required:true
    },
    methodName: {
      required:true
    },
    vehicleTypeId: {
      required:true
    },
    brandId: {
      required:false
    },
    modelId: {
      required:false
    },
    initialName :{
      required:false
    }
  },

  mounted() {
    this.baseVehicle.name=this.initialName
    this.baseVehicle.id=null
    this.baseVehicle.state = null
    this.baseVehicle.invalidFeedback = null
  },

  watch:{
    'initialName': {
      immediate:true,
      handler () {
        this.baseVehicle.name= this.initialName
      }
    },
  },

  methods: {
    async handleSubmit(){
      let data = new FormData()
      data.append('name', this.baseVehicle.name)
      data.append('vehicleTypeId', this.vehicleTypeId)
      if(this.brandId){
        data.append('brandId', this.brandId)
      }
      if(this.modelId){
        data.append('modelId', this.modelId)
      }

      api({
        method: "POST",
        url: `/${this.controllerName}/${this.methodName}`,
        data: data
      })
        .then((response) => {
          if(response.data.id){
            this.baseVehicle={...response.data}
            this.$emit('returnCreateCustom',{...response.data})
            this.$bvModal.hide('create-vehicle-generic')
            this.baseVehicle.name=null
            this.baseVehicle.id=null
            this.baseVehicle.state = null
            this.baseVehicle.invalidFeedback = null
          }
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 403) {
            this.baseVehicle['state'] = false
            this.baseVehicle['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    async handleOk(e) {
      e.preventDefault()
      await this.handleSubmit()
    },

    hideModal() {
      this.$bvModal.hide('create-vehicle-generic')
      this.baseVehicle.state = null
      this.baseVehicle.invalidFeedback = null
    },
  },
};
</script>

<!-- not scoped car modal --><style>


#create-vehicle-generic .modal-content,
#create-vehicle-generic .modal-header,
#create-vehicle-generic .modal-body,
#create-vehicle-generic .modal-footer{
  background-color: var(--main-black-dark) !important;
}


#create-vehicle-generic .modal-content {
  overflow: hidden!important;
  border-radius: 30px!important;
}



@media (max-width: 767px) {
  #create-vehicle-generic .modal-content {
    display: flex;
    overflow: auto;
  }
  #create-vehicle-generic .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #create-vehicle-generic .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #create-vehicle-generic .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #create-vehicle-generic .modal-content {
    padding: 0;
    margin-right: 10px;
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/annonce/AnnonceCreateVehicleGenericModal.vue